<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [searchText]="searchText"
   [pagingCallState]="pagingCallState"
   [hideHeader]="hideHeader"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="phoneNumber" width="4">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="phoneNumber-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="phoneNumber"
               >Phone Number<mat-icon class="mat-icon-sort">{{ getSort('phoneNumber') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <div class="phone-number-wrapper">
                  <mat-icon
                     class="small-icon"
                     (click)="
                        copyPhoneNumberToClipboard(phoneNumber.phoneNumber);
                        $event.preventDefault();
                        $event.stopPropagation()
                     "
                  >
                     content_copy
                  </mat-icon>

                  <a [routerLink]="getRouterLink(phoneNumber.phoneNumberId)">
                     {{ phoneNumber.phoneNumber | formatPhoneNumbers }}
                  </a>
               </div>
            </td>
         </ng-container>

         <ng-container lcsColumnDef="location" width="6">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="location-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="location.name, location.houseNumber"
            >
               Location<mat-icon class="mat-icon-sort">{{ getSort('location.name') }}</mat-icon>
            </th>
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getRouterLink(phoneNumber.phoneNumberId)">
                  @if (phoneNumber.location?.name) {
                  {{ phoneNumber.location.name }} - }
                  {{ phoneNumber.location | ndtStreet }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="faxExtensionId" width="2">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="isFax-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="faxExtensionId"
               >Fax<mat-icon class="mat-icon-sort">{{ getSort('faxExtensionId') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getRouterLink(phoneNumber.phoneNumberId)">
                  @if (phoneNumber.faxExtension) {
                  <mat-icon>check</mat-icon>
                  }
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="openExtension" width="6">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="openExtension-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="displayExtensionNumber"
               >Open Extension<mat-icon class="mat-icon-sort">{{ getSort('displayExtensionNumber') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getRouterLink(phoneNumber.phoneNumberId)">
                  {{ phoneNumber.faxExtension ? phoneNumber.faxExtension : phoneNumber.openExtension }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="closedExtension" width="6">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="closedExtension-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="closedExtension.number"
               >Closed Extension<mat-icon class="mat-icon-sort">{{ getSort('closedExtension.number') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getRouterLink(phoneNumber.phoneNumberId)">
                  {{ phoneNumber.closedExtension }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="schedule" width="4">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="schedule-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="schedule.name"
               >Schedule<mat-icon class="mat-icon-sort">{{ getSort('schedule.name') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getRouterLink(phoneNumber.phoneNumberId)">
                  {{ phoneNumber.schedule }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="isActive" width="2">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="isActive-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="isActive"
               >Active<mat-icon class="mat-icon-sort">{{ getSort('isActive') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getRouterLink(phoneNumber.phoneNumberId)">
                  @if (phoneNumber.isActive) {
                  <mat-icon>check</mat-icon>
                  }
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="isE911Registered" width="2">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="isE911Registered-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="isE911Registered"
               >E911<mat-icon class="mat-icon-sort">{{ getSort('isE911Registered') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getRouterLink(phoneNumber.phoneNumberId)">
                  @if (phoneNumber.isE911Registered) {
                  <mat-icon>check</mat-icon>
                  }
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="accountPhoneNumberActionsMenu" width="0.75">
            <th lcs-header-cell *lcsHeaderCellDef id="account-phone-number-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <button
                  type="button"
                  aria-label="Phone Number Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="accountPhoneNumbersMenu"
                  id="account-phone-number-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               <mat-menu #accountPhoneNumbersMenu="matMenu">
                  <a mat-menu-item [routerLink]="getRouterLink(phoneNumber.phoneNumberId)"> Details </a>
                  <button type="button" mat-menu-item (click)="copyPhoneNumberToClipboard(phoneNumber.phoneNumber)">
                     Copy Phone Number
                  </button>
                  @if (canRelease(phoneNumber)) {
                  <button
                     mat-menu-item
                     type="button"
                     (click)="onReleaseAccountClick(phoneNumber); $event.preventDefault(); $event.stopPropagation()"
                     id="phone-number-release"
                  >
                     Release Phone Number
                  </button>
                  } @if (canDelete(phoneNumber)) {
                  <button
                     mat-menu-item
                     type="button"
                     (click)="onDeleteClick(phoneNumber); $event.preventDefault(); $event.stopPropagation()"
                     id="phone-number-delete"
                  >
                     Delete Phone Number
                  </button>
                  }
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
